import { c as _c } from "react/compiler-runtime";
import type { RangeCalendarStateOptions } from '@react-stately/calendar';
import { I18nProvider } from 'react-aria';
import { DateRangePickerProvider } from '../core/date-picker-provider';
import { Root } from '../core/root';
import type { DateRange, RenderDateProps } from '../datepicker';
import { Month } from './month';
import { useDateRangePickerConfig } from './use-date-range-picker-config';
export type DateRangePickerProps = Omit<RangeCalendarStateOptions, 'minValue' | 'maxValue' | 'defaultValue' | 'value' | 'onChange' | 'createCalendar' | 'locale'> & {
  value?: DateRange;
  defaultValue?: DateRange;
  min: Date;
  max: Date;
  initialHideRangeMarkers?: boolean;
  onChange: (value: [Date, Date | null] | null) => void;
  weekDayLabel?: (date: Date) => string;
  gridLabel?: (date: Date) => string;
  renderDate?: (cell: RenderDateProps) => React.ReactNode;
  initialDate?: Date;
};
export function DateRangePicker(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <I18nProvider locale="de-DE"><DateRangePickerContent {...props} /></I18nProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function DateRangePickerContent(props) {
  const $ = _c(14);
  const config = useDateRangePickerConfig(props);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Month />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== config.isMobile) {
    t1 = !config.isMobile && <Month offset={{
      months: 1
    }} />;
    $[1] = config.isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== config.calendarProps || $[4] !== config.calendarRef || $[5] !== config.gridLabel || $[6] !== config.nextButtonProps || $[7] !== config.prevButtonProps || $[8] !== config.state || $[9] !== t1) {
    t2 = <Root state={config.state} calendarProps={config.calendarProps} calendarRef={config.calendarRef} prevButtonProps={config.prevButtonProps} nextButtonProps={config.nextButtonProps} gridLabel={config.gridLabel}>{t0}{t1}</Root>;
    $[3] = config.calendarProps;
    $[4] = config.calendarRef;
    $[5] = config.gridLabel;
    $[6] = config.nextButtonProps;
    $[7] = config.prevButtonProps;
    $[8] = config.state;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== config || $[12] !== t2) {
    t3 = <DateRangePickerProvider config={config}>{t2}</DateRangePickerProvider>;
    $[11] = config;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}